<template>
  <div class="uploadCom t_center">
    <div>
      <slot name="block"></slot>
    </div>
    <input type="file" accept="image/*" multiple @change="imgChang(this)" ref="input"/>
  </div>
</template>

<script>
  // import order from '@/axios/order'
  // const MAX_SIZE = 1 * 1024 * 1026
  import myApi from '@/axios/my'
  export default {
    props: {},
    name: 'uploadCom',
    methods: {
      imgChang (file) {
        const files = this.$refs["input"].files
        const image = new Image()
        const reader = new FileReader()
        const _this = this
        console.log(files)
        if(!files[0].type||files[0].type.indexOf("image")<0){
            this.$vux.toast.text("请选择正确的图片格式上传")
            return false
        }

        _this.upload(files[0])
        //是否需要验证图片大小？
        // if(files[0].size < MAX_SIZE){//没有超过限制
        //     _this.upload(files[0])
        //     return
        // }

        // //读取base64图片数据
        // reader.readAsDataURL(files[0])
        // reader.onload = function (  ) {
        //     image.src = this.result
        //     image.onload = function (  ) {
        //         _this.upload(_this.compress(image))
        //     }
        //     image.onerror = function ( err ) {
        //         console.log(err)
        //     }
        // }
      },
      upload (file) {
        let formData = new FormData()
        formData.append('file', file)
        myApi.uploadImg(formData)
          .then(res=>{
              this.$refs["input"].value = ""
              this.$emit("on-change",res)
              formData = null
          })
          .catch(err=>{
            this.$refs["input"].value = ""
          })
      }
    }
  }
</script>

<style scoped lang="scss">
  .uploadCom{
    width:190px;
    height:190px;
    background: $border-color url("/images/public/upoad_plus.png") no-repeat center center;
    background-size: 124px;
    border-radius: $base-radius;
    input{
      width:190px;
      height:190px;
      opacity: 0;
    }
  }
</style>
